import { sortJobsByDates } from 'utils/shared/sortJobsByDates';

import type { CandidateDto } from '../candidate.dto';

export type Experience = {
  role: string;
  companyName: string | undefined;
  startDate: { month: number | undefined; year: number | undefined };
  endDate: { month: number | undefined; year: number | undefined };
  startEpochTimeInMonths: number;
  endEpochTimeInMonths: number | undefined;
  description: string | undefined;
};

export const toExperiences = (dto: CandidateDto): Experience[] => {
  const sortedJobs = sortJobsByDates(dto._source.experiences.jobs);

  return sortedJobs.map<Experience>((job) => ({
    role: job.role,
    companyName: job.company?.name,
    startDate: {
      month: job.dates.start?.month,
      year: job.dates.start?.year,
    },
    endDate: {
      month: job.dates.end?.month,
      year: job.dates.end?.year,
    },
    startEpochTimeInMonths: job.dates.start_recalculated,
    endEpochTimeInMonths: job.dates.end_recalculated,
    description: job.description ?? undefined,
  }));
};
